export var provideMenuKey = Symbol();
